<div class="ai-chat-container" [class.open]="isOpen">
  <!-- Chat Window (Glassmorphic) -->
  <div class="chat-window">
    <div class="chat-header">
      <div class="header-info">
        <mat-icon fill="primary">psychology</mat-icon>
        <span class="header-title">AI Task Assistant</span>
      </div>
      <div class="header-actions">
        <button *ngIf="isMasterAdmin" 
                class="seed-btn-header" 
                (click)="seedDatabase()" 
                title="Refresh AI Knowledge Base"
                [disabled]="isLoading">
          <mat-icon>refresh</mat-icon>
        </button>
        <button class="close-btn" (click)="toggleChat()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Messages Area -->
    <div class="chat-messages" #scrollMe>
      <div *ngFor="let msg of messages" class="message-wrapper" [class.user-wrapper]="msg.sender === 'user'">
        <div class="message-bubble" [class.ai-bubble]="msg.sender === 'ai'" [class.user-bubble]="msg.sender === 'user'">
          <div class="message-content">{{ msg.text }}</div>
          <div class="message-meta">
            <!-- <span class="message-tokens" *ngIf="msg.tokenUsage" title="AI tokens used for this query">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display: inline-block; vertical-align: middle; margin-right: 2px;">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
              </svg>
              {{ msg.tokenUsage }} tokens
            </span> -->
            <span class="message-time">{{ msg.timestamp | date:'shortTime' }}</span>
          </div>
        </div>
      </div>

      <!-- Typing indicator when loading -->
      <div *ngIf="isLoading" class="message-wrapper">
        <div class="message-bubble ai-bubble typing-bubble">
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Input Area -->
    <div class="chat-input-area">
      <input 
        type="text" 
        [(ngModel)]="userInput" 
        (keyup.enter)="sendMessage()" 
        placeholder="Ask about tasks, tenants, or sites..."
        [disabled]="isLoading"
      />
      <button class="send-btn" (click)="sendMessage()" [disabled]="!userInput.trim() || isLoading">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>

  <!-- Trigger Button (Floating FAB) -->
  <button class="chat-trigger" (click)="toggleChat()">
    <mat-icon *ngIf="!isOpen">chat</mat-icon>
    <mat-icon *ngIf="isOpen">expand_more</mat-icon>
  </button>
</div>
